import { format } from 'date-fns';
import { FilterEntity } from '@/utils';

export const getQueryObjKeys = <T extends FilterEntity>(Filter: new () => T) => {
  return ['perPage', 'page', ...Object.keys(new Filter())];
};

export const getTimezoneOffset = () => format(new Date(), 'XXXXX');
